module.exports = __webpack_public_path__ + "assets/img/13.6cc76a18.png";